<template>
    <div class="card mt-3">
        <div class="card-header">
            <h5 class="d-inline">Polling Group {{ pollingGroup.pollingGroupId }}</h5>
            <button
                class="btn btn-sm btn-light float-right d-inline py-0"
                @click="removePollingGroup">
                &times; Remove
            </button>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="form-group row col-6">
                    <div class="col-4">
                        <label class="col-form-label col-form-label-sm">Polling Interval (in seconds)</label>
                    </div>
                    <div class="col-md-8">
                        <input
                            type="text"
                            class="form-control form-control-sm"
                            :class="{ 'is-invalid': pollingIntervalError }"
                            v-model="pollingGroup.pollingInterval"
                            @change="validatePollingInterval" />
                        <div class="invalid-feedback">Integers only</div>
                    </div>
                </div>
                <div class="form-group row col-6">
                    <div class="col-4">
                        <label class="col-form-label col-form-label-sm">Log Type</label>
                    </div>
                    <div class="col-md-8">
                        <select
                            class="form-control form-control-sm"
                            v-model="pollingGroup.logType">
                            <option value="0">Differential logging</option>
                            <option value="1">Log all data</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <h6 class="card-title"><strong>Device Status Reporting:</strong></h6>
                    <div class="row">
                        <div class="form-group row col-6">
                            <div class="col-4">
                                <label class="col-form-label col-form-label-sm">Enable GPS Reporting?</label>
                            </div>
                            <div class="col-md-8">
                                <select
                                    class="form-control form-control-sm"
                                    v-model="pollingGroup.gpsReportingState">
                                    <option value="0">No</option>
                                    <option value="1">Yes</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row col-6">
                            <div class="col-4">
                                <label class="col-form-label col-form-label-sm">Enable LAN Reporting Agent?</label>
                            </div>
                            <div class="col-md-8">
                                <select
                                    class="form-control form-control-sm"
                                    v-model="pollingGroup.lanReportingState">
                                    <option value="0">No</option>
                                    <option value="1">Yes</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row col-6">
                            <div class="col-4">
                                <label class="col-form-label col-form-label-sm">Enable WAN Reporting Agent?</label>
                            </div>
                            <div class="col-md-8">
                                <select
                                    class="form-control form-control-sm"
                                    v-model="pollingGroup.wanReportingState">
                                    <option value="0">No</option>
                                    <option value="1">Yes</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row col-6">
                            <div class="col-4">
                                <label class="col-form-label col-form-label-sm">Enable Cellular Reporting Agent?</label>
                            </div>
                            <div class="col-md-8">
                                <select
                                    class="form-control form-control-sm"
                                    v-model="pollingGroup.cellularReportingState">
                                    <option value="0">No</option>
                                    <option value="1">Yes</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row col-6">
                            <div class="col-4">
                                <label class="col-form-label col-form-label-sm">Enable General Info Reporting Agent?</label>
                            </div>
                            <div class="col-md-8">
                                <select
                                    class="form-control form-control-sm"
                                    v-model="pollingGroup.generalReportingState">
                                    <option value="0">No</option>
                                    <option value="1">Yes</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <query
                v-if="pollingGroup.queryArr.length > 0"
                v-for="query in pollingGroup.queryArr"
                :modbusConfig="modbusConfig"
                :query="query"
                :key="query.queryId"
                :loggingMethod="loggingMethod"
                @tagAdded="addTag"
                @queryRemoved="removeQuery($event)"
                @tagRemoved="removeTag($event)"></query>
            <button
                class="btn btn-outline-info btn-sm mt-3"
                @click="addQuery">+ Add Query</button>
        </div>
    </div>
</template>

<script>
import Query from './Query.vue'

export default {
    components: {
        'query': Query
    },
    data() {
        return {
            pollingIntervalError: false
        }
    },
    props: ['modbusConfig', 'pollingGroup', 'loggingMethod'],
    methods: {
        addQuery() {
            this.$emit('queryAdded', this.pollingGroup.pollingGroupId)
        },
        addTag(queryId) {
            let selectedQueryArrIndex = this.pollingGroup.queryArr.findIndex((el) => {
                return el.queryId === queryId
            })
            this.$emit('tagAdded', this.pollingGroup.pollingGroupId, selectedQueryArrIndex)
        },
        validatePollingInterval() {
            if(!/^\d+$/.test(this.pollingGroup.pollingInterval)) {
                this.pollingIntervalError = true
            } else {
                this.pollingIntervalError = false
            }
        },
        removePollingGroup() {
            this.$emit('pollingGroupRemoved', { pollingGroupId: this.pollingGroup.pollingGroupId })
        },
        removeQuery($event) {
            this.$emit('queryRemoved', {
                queryId: $event.queryId,
                pollingGroupId: this.pollingGroup.pollingGroupId
            })
        },
        removeTag($event) {
            this.$emit('tagRemoved', {
                tagId: $event.tagId,
                queryId: $event.queryId,
                pollingGroupId: this.pollingGroup.pollingGroupId
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/polling-group/PollingGroup.vue